import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  cancel: () => __(translations.imageCropPicker.cancel, 'Cancel'),
  confirm: () => __(translations.imageCropPicker.confirm, 'Confirm'),
  instructions: () => __(translations.imageCropPicker.instructions, 'Drag the handles to crop the image to the desired dimensions'),
  uploadImage: () => __(translations.imageCropPicker.uploadImage, 'Upload image'),
};
